/*eslint-env browser*/
/*global Cookies*/
'use strict';

// Blacksheep: user experimentation like AB BAA and ABBA testing
var Blacksheep = {};

// Adapted from node-uuid ()
Blacksheep.hex = (function () {
    var map = {};

    for (var i = 0; i < 256; i++) {
        map[(i + 0x100).toString(16).substr(1)] = i;
    }

    return map;
}());

// Fixed random generator from a v4 uuid
// d7521a29-5fcc-4d4c-8dd8-a9e17157dcea
//
// http://xkcd.com/221/ "From server uuid, guarenteed to be random"
Blacksheep.segment = function (uuid, segment, num) {
    if (!uuid || typeof uuid !== 'string') {
        return null;
    }

    // Strip version and variant bytes from UUID
    uuid = uuid.toLowerCase();
    uuid = uuid.replace(/-/g, '');

    if (uuid.charAt(12) !== '4' || uuid.length !== 32) {
        // Only v4 UUIDs are supported
        return null;
    }

    // Remove non-random chars
    uuid = uuid.slice(0, 12) + uuid.slice(13, 16) + uuid.slice(17);

    var byte = Blacksheep.hex[uuid.slice(segment, segment + 2)];

    return Math.floor((byte / 256) * num);
};

Blacksheep.experiment = function (segment, identity, buckets) {
    var bucket = Blacksheep.segment(identity, segment, buckets.length);

    if (bucket === null) {
        return null;
    }

    if (isNaN(bucket)) {
        return null;
    }

    return buckets[bucket];
};

if (typeof module === 'object') {
    module.exports = Blacksheep;
}

if (typeof window === 'object') {
    window.Blacksheep = Blacksheep;
}
